import { ChainIdEnum } from 'config/constants/network'
import { Token } from 'config/types'
import Column from 'layout/Components/Column'
import { RowBetween } from 'layout/Components/Row'
import React from 'react'
import { useListTokens } from 'state/app/hooks'
import { ModalBody, ModalHeader, ModalProps } from 'UIKit/AlchemyModal'
import Box from 'UIKit/Box/Box'

import Text from 'UIKit/Text'
import TokenLogo from 'UIKit/TokenLogo'
import { getTokenName } from 'utils/token'
import { PAYMENT_MODAL_THEME, PaymentWrapOption, StylePaymentModal } from './styles'

interface FiatCurrencySelectProps {
  onTokenChange: (token: Token, selectNetwork: boolean) => void
  selectedToken: Token
}

const FiatCurrencySelectModal: React.FC<ModalProps<FiatCurrencySelectProps>> = ({
  data: { onTokenChange, selectedToken },
  onDismiss,
}) => {
  const currencies = useListTokens(ChainIdEnum.FIAT)

  return (
    <StylePaymentModal colorTheme={PAYMENT_MODAL_THEME} onDismiss={onDismiss}>
      <ModalHeader colorTheme={PAYMENT_MODAL_THEME} titleAlign="center" title={'Choose Currency'} />
      <ModalBody>
        <Column gap="12px">
          {currencies.map((currency) => (
            <PaymentWrapOption
              selected={currency.code === selectedToken?.code}
              onClick={() => {
                onTokenChange(currency, true)
                onDismiss()
              }}
            >
              <Box minWidth="32px">
                <TokenLogo
                  token={currency}
                  size={32}
                  hideNetwork
                  networkImageProps={{
                    width: 16,
                    height: 16,
                  }}
                />
              </Box>
              <RowBetween>
                <Column>
                  <Text bold lineHeight="22px" fontSize="16px" letterSpacing={'-0.43px'} ellipsis={1}>
                    {currency.code}
                  </Text>
                  <Text
                    fontSize="12px"
                    lineHeight="20px"
                    letterSpacing={'-0.23px'}
                    fontWeight={500}
                    color="var(--pm-text-note-color)"
                  >
                    {currency?.displayName || getTokenName(currency)}
                  </Text>
                </Column>
              </RowBetween>
            </PaymentWrapOption>
          ))}
        </Column>
      </ModalBody>
    </StylePaymentModal>
  )
}

export default FiatCurrencySelectModal
